<template>
  <div class="comparison-table">
    <!-- 功能对比表格 -->
    <div class="table-container">
      <table class="feature-table">
        <thead>
          <tr>
            <!-- 版本标题行 -->
            <th class="empty-header"></th>
            <th class="empty-header"></th>
            <th class="empty-header-desc"></th>
            <th colspan="2" class="version-header">进阶版</th>
            <th colspan="2" class="version-header">敏捷版</th>
            <th colspan="2" class="version-header">免费版</th>
          </tr>
          <tr>
            <th class="module-col">功能模块</th>
            <th class="list-col">功能清单</th>
            <th class="desc-col">功能描述</th>
            <th class="platform-col">Web</th>
            <th class="platform-col">APP</th>
            <th class="platform-col">Web</th>
            <th class="platform-col">APP</th>
            <th class="platform-col">Web</th>
            <th class="platform-col">APP</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(module, mIndex) in tableData">
            <tr
              v-for="(item, iIndex) in module.moduleList"
              :key="`${mIndex}-${iIndex}`"
            >
              <!-- 模块名只在第一行显示 -->
              <td
                v-if="iIndex === 0"
                :rowspan="module.moduleList.length"
                class="module-row"
              >
                {{ module.moduleName }}
              </td>
              <td class="list-row">{{ item.name }}</td>
              <td class="desc-row">{{ item.desc }}</td>

              <!-- 专业版 -->
              <td>
                <span class="icon" :class="item.pro.web ? 'check' : 'dash'">
                  {{ item.pro.web ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.pro.web ? 'check' : 'dash'"></i> -->
              </td>
              <td>
                <span class="icon" :class="item.pro.app ? 'check' : 'dash'">
                  {{ item.pro.app ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.pro.app ? 'check' : 'dash'"></i> -->
              </td>

              <!-- 敏捷版 -->
              <td>
                <span class="icon" :class="item.agile.web ? 'check' : 'dash'">
                  {{ item.agile.web ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.agile.web ? 'check' : 'dash'"></i> -->
              </td>
              <td>
                <span class="icon" :class="item.agile.app ? 'check' : 'dash'">
                  {{ item.agile.app ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.agile.app ? 'check' : 'dash'"></i> -->
              </td>

              <!-- 免费版 -->
              <td>
                <span class="icon" :class="item.free.web ? 'check' : 'dash'">
                  {{ item.free.web ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.free.web ? 'check' : 'dash'"></i> -->
              </td>
              <td>
                <span class="icon" :class="item.free.app ? 'check' : 'dash'">
                  {{ item.free.app ? '✔️' : '-' }}
                </span>
                <!-- <i class="icon" :class="item.free.app ? 'check' : 'dash'"></i> -->
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- 展开按钮（可选，如果需要分页或懒加载） -->
    <div class="expand-btn" @click="expandedClick">
      <span>{{ expanded ? '收起权益对比详情' : '展开权益对比详情' }}</span>
      <i class="icon arrow" :class="{ up: expanded }"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comparTable',
  data() {
    return {
      expanded: false,
      tableData: [],

      moduleData: [
        {
          moduleName: 'AI智能识单',
          moduleList: [
            {
              name: 'AI识单买纸板',
              desc:
                '①告别手动录单，高效识别终端纸箱采购单，批量转化成纸板采购单\n②省去线下人工计算转化环节，让采购工作快人一步',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            },
            {
              name: 'AI识单纸板收货',
              desc: '无需翻单！纸板到货拍照秒识别，收货入库超省力',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            },
            {
              name: 'AI识单纸板对账',
              desc: '无需提前录单！纸板到货拍照秒识别，一键记账实时对账',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            },
            {
              name: 'AI识单纸箱送货',
              desc:
                '告别手动录单，高效识别终端纸箱采购单，批量转化成纸箱送货单',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            }
          ]
        },
        {
          moduleName: '经营看板',
          moduleList: [
            {
              name: '经营看板',
              desc:
                '展示纸箱厂的不同时间维度的销售、送货、采购、财务等统计数据',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            }
          ]
        },
        {
          moduleName: '客户管理',
          moduleList: [
            {
              name: '客户档案',
              desc:
                '①客户统一管理，避免资料丢失\n②客户账期授信预警，系统自动提醒\n财务灵活设置，账单自动生成',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '产品档案',
              desc:
                '①精确管理每个客户的每个产品\n②自动计算纸箱成本和毛利\n③关联图纸，自动为生产提供依据\n④实现按材料/产品批量调价，提高效率，避免出错',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '物料管理',
              desc:
                '灵活管理纸箱套装内的缓冲材料配件（如纸护角、蜂窝板、海绵等非瓦楞纸板）',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '订单管理',
          moduleList: [
            {
              name: '订单管理',
              desc:
                '①纸箱开单，自动同步产品档案\n②多样式的生产流程单，自动生成二维码（计件、入库、送货）\n③订单状态可视化',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '售后管理',
              desc:
                '售后服务可精准追溯至每笔订单，关联的对账信息与成本清晰可查。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '采购管理',
          moduleList: [
            {
              name: '供应商管理',
              desc:
                '①纸板、印版、刀模、辅料供应商统一管理，信息防丢失\n②纸板供应商支持不同计价方案，让你算价无忧',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '材料档案',
              desc: '①多供应商材料统一管理\n②支持纸板材料的批量新增和批量改价',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            },
            {
              name: '纸板采购',
              desc:
                '①根据订单自动生成采购单 \n②采购单状态全流程可视\n③支持多渠道采购，统一管理',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: true, app: true }
            }
          ]
        },
        {
          moduleName: '生产管理',
          moduleList: [
            {
              name: '生产排产',
              desc: '灵活制定生产计划',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '生产计件',
              desc: '①实时掌控各工序生产进度\n②手机扫码精准报工计件',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '仓库管理',
          moduleList: [
            {
              name: '定制纸箱',
              desc:
                '①手机扫码入库，提高工作效率\n②实时掌握库存数量、面积、金额。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '通用纸箱',
              desc:
                '支持“先备货、后分配”的敏捷模式。当不同的客户需要时，可直接调用库存，并即时为其创建专属订单或送货单。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '纸板库存',
              desc:
                '灵活设置纸板库存预警，实时掌握余量。确保原料充足，有效避免因缺料导致的生产中断，保障订单顺畅交付。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '印版库存',
              desc:
                '支持印版入库、领用、归还，避免印版因未及时入库、丢失、老化而造成生产中断，保障订单顺畅交付。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '刀模库存',
              desc:
                '支持刀模入库、领用、归还，避免刀模因未及时入库、丢失、老化而造成生产中断，保障订单顺畅交付。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '辅料库存',
              desc:
                '支持辅料入库、领用、归还，避免辅料因未及时入库、丢失、老化而造成生产中断，保障订单顺畅交付。',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '送货管理',
          moduleList: [
            {
              name: '送货管理',
              desc:
                '①一键生成送货单，无需人工重复录入\n②支持手机远程打印\n③支持拍照上传回单，永久保存',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '财务管理',
          moduleList: [
            {
              name: '对账单',
              desc:
                '①自动生成对账单，无需人工统计\n②支持微信转发、导出表格文件及打印',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '应收账款',
              desc: '随时记录/查看客户账款明细及开票记录',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '送货明细',
              desc: '送货记录和对账记录对比一目了然',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '收款总明细',
              desc: '记录全部客户收款明细',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '应付账款',
              desc: '随时记录/查看供应商账款明细及开票记录',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: true, app: true }
            },
            {
              name: '付款总明细',
              desc: '记录全部供应商付款明细',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: true, app: true }
            }
          ]
        },
        {
          moduleName: '员工管理',
          moduleList: [
            {
              name: '员工管理',
              desc:
                '①根据不同工种，权限灵活管控\n②员工小程序计件，快捷方便\n③员工权限隔离，只看自己数据',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            }
          ]
        },
        {
          moduleName: '基础设置',
          moduleList: [
            {
              name: '基础设置',
              desc: '基础信息、送货单、打印设置',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '产品设置',
              desc: '工序、面积公式、压线公式设置',
              pro: { web: true, app: true },
              agile: { web: true, app: true },
              free: { web: false, app: false }
            },
            {
              name: '报价设置',
              desc:
                '印刷、模切、粘合方式、打包方式、特殊工艺、账期、模板费、其他各模块的自定义字段、单价等配置',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            },
            {
              name: '辅料设置',
              desc: '辅料类型设置',
              pro: { web: true, app: true },
              agile: { web: false, app: false },
              free: { web: false, app: false }
            }
          ]
        }
      ]
    }
  },
  mounted() {
    this.tableData = [this.moduleData[0]]
  },
  methods: {
    expandedClick() {
      this.expanded = !this.expanded
      if (this.expanded) {
        this.tableData = this.moduleData
      } else {
        this.tableData = [this.moduleData[0]]
      }
    }
  }
}
</script>

<style scoped>
.comparison-table {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

.table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* 优化iOS滑动体验 */
}

.feature-table {
  width: 100%;
  min-width: 700px; /* 确保表格在小屏下可以滑动 */
  border-collapse: collapse;
  table-layout: fixed;
}

.feature-table th {
  background-color: #f5f5f5;
  padding: 12px 8px;
  font-weight: 600;
  color: #666;
  text-align: center;
  border-bottom: 2px solid #e6e6e6;
  font-size: 14px;
}

.feature-table td {
  padding: 12px 8px;
  border-bottom: 1px solid #eee;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
}

.module-col {
  width: 100px;
  text-align: left;
  padding-left: 16px;
  font-weight: 500;
  color: #333;
}

.list-col {
  width: 100px;
  text-align: left;
  padding-left: 16px;
}

.desc-col {
  width: 300px;
  text-align: left;
  padding-left: 16px;
  color: #333;
  word-break: break-all; /* 关键修复：强制换行 */
  white-space: normal; /* 关键修复：允许换行 */
}

.desc-row {
  background-color: #fff;
  word-break: break-all; /* 确保描述行内容换行 */
  /* white-space: normal; */
  white-space: pre-line;
  text-align: left !important;
}

.platform-col {
  width: 30px;
}

.empty-header {
  width: 100px;
  background: transparent;
  border: none;
}
.empty-header-desc {
  width: 300px;
  background: transparent;
  border: none;
}

.module-row {
  background-color: #f9f9f9;
  font-weight: 500;
}

.list-row,
.desc-row {
  background-color: #fff;
}

.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
}

.icon.check {
  color: #666;
  font-weight: bold;
}

.icon.dash {
  color: #ccc;
  font-weight: normal;
}

.expand-btn {
  text-align: center;
  padding: 16px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  border-top: 1px solid #eee;
  transition: all 0.3s;
}

.expand-btn:hover {
  color: #c78b3d;
}

.arrow {
  display: inline-block;
  margin-left: 6px;
  transition: transform 0.3s;
}

.arrow.up {
  transform: rotate(180deg);
}

/* 版本标题样式 */
.version-header {
  background-color: #eef5ff;
  padding: 10px 8px;
  font-weight: bold;
  color: #333;
  text-align: center;
  border-bottom: 2px solid #b3daff;
  font-size: 15px;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .feature-table {
    font-size: 12px;
  }

  .module-col,
  .list-col {
    width: 80px;
  }

  .desc-col {
    width: 200px;
  }
  .desc-col {
    width: 200px;
    word-break: break-all;
    white-space: normal;
  }

  .platform-col {
    width: 45px;
  }

  .empty-header {
    width: 80px;
  }
}
</style>
